// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import locationTypeTranslations from 'infras/i18n/locales/location_type.json';
import PaymentDetail from 'presentations/views/components/molecules/PaymentDetail';
import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import { formatContactName } from 'presentations/views/helpers/formatter';
import { gray01, gray04, primary } from 'presentations/views/styles/color';
import { fontSize, spacing, mediaMax } from 'presentations/views/styles';
import { EventContactItem } from 'presentations/api/schema/event_contact';
import { ViewerItem } from 'presentations/api/schema/user';
import { SharedEventDetailItem } from 'presentations/api/schema/event';
import { getDateTime } from 'infras/datetime';
import { PaymentMethod } from 'domains/models/event_payment/payment_method';

interface Props {
  viewer: ViewerItem | null;
  event?: SharedEventDetailItem;
  eventContact?: EventContactItem;
  isShowNotice?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent([translations, locationTypeTranslations]);

  const isEventMember = props?.event?.users.some(
    (user) => user.uid === props.viewer?.uid,
  );

  const isShowPrice = props.event?.payment?.items.some(
    (item) => item.isShowPrice,
  );

  return (
    <Container>
      {props.eventContact && (
        <GuestSummary>
          <GuestTitle>{t('guest summary title')}</GuestTitle>
          <GuestSummaryList>
            <SummaryListItem>
              <ListItemIcon name="person" />
              <ListItemText>
                {formatContactName(props.eventContact)}
              </ListItemText>
            </SummaryListItem>
            {isEventMember && (
              <>
                <SummaryListItem>
                  <ListItemIcon name="mail" />
                  <ListItemText>{props.eventContact.email}</ListItemText>
                </SummaryListItem>
                {props.eventContact.phoneNumber && (
                  <SummaryListItem>
                    <ListItemIcon name="phone" />
                    <ListItemText>
                      {props.eventContact.phoneNumber}
                    </ListItemText>
                  </SummaryListItem>
                )}
                {props.eventContact.textRemindCountryCode &&
                  props.eventContact.textRemindNumber && (
                    <SummaryListItem>
                      <ListItemIcon name="message-badge" />
                      <ListItemText>
                        {props.eventContact.textRemindCountryCode}
                        {props.eventContact.textRemindNumber}
                      </ListItemText>
                    </SummaryListItem>
                  )}
              </>
            )}

            {props.eventContact.message && (
              <SummaryListItem>
                <ListItemIcon name="comment" />
                <ListItemText>{props.eventContact.message}</ListItemText>
              </SummaryListItem>
            )}
          </GuestSummaryList>
        </GuestSummary>
      )}
      {props?.event?.payment && isShowPrice && (
        <EventPaymentContainer>
          <PaymentDetail
            isNoBorder={false}
            isShowSchedule={false}
            isShowPaymentMethodOnly={
              props.event.payment.paymentMethod === PaymentMethod.Card
            }
            eventPayment={props.event.payment!}
            startDatetime={getDateTime(
              props.event.startedAt,
              props.event.timeZone,
            )}
            endDatetime={getDateTime(props.event.endedAt, props.event.timeZone)}
            timeZone={props.event.timeZone}
          />
        </EventPaymentContainer>
      )}
      {/* {props.isShowNotice && (
        <>
          <Hr />
          <Notice>{t('EventNotice')}</Notice>
        </>
      )} */}
    </Container>
  );
}

const Container = styled.div``;

const SummaryListItem = styled.li`
  color: ${gray01};
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(16)};
  :last-of-type {
    margin-bottom: 0;
  }
`;
const ListItemIcon = styled(Icon)`
  margin-right: ${spacing(8)};
  font-size: ${fontSize(20)};
`;
const ListItemText = styled.span`
  color: ${gray01};
`;

const GuestSummary = styled.div``;
const GuestTitle = styled.h3`
  margin-bottom: ${spacing(16)};
`;
const GuestSummaryList = styled.ul``;

const EventPaymentContainer = styled.div`
  margin-top: ${spacing(16)};
  width 50%;
  ${mediaMax.tablet} {
    width 100%;
  }
`;
